<template>
  <loading :active="loading"
           :can-cancel="true"
           :on-cancel="onCancel"
           :is-full-page="fullPage">
  </loading>
  <my_register_notice v-if="isLoggedIn == false"></my_register_notice>
  <section class="container mx-auto lg:py-6 md:p-0" v-if="is_join == false && isLoggedIn == true">
    <div class="bg-white">
      <div class="max-w-8xl mx-auto py-4 px-6 lg:max-w-7xl lg:px-8 bg-white">
        <div class="w-full lg:flex lg:justify-start">
          <div class="w-full">
            <div class="max-w-8xl mx-auto lg:max-w-7xl lg:pl-8 lg:pr-0">
              <div class="w-full pb-10">
                <div class="flex justify-start item-start flex-col">
                  <h2 class="xl:text-2xl lg:text-xl text-lg mt-3 mb-6 font-semibold">Registration</h2>
                  <div class="w-full bg-white lg:p-2" id="infomodify" >
                    <div class="mt-6 text-center text-red-500 font-semibold text-lg" v-if="isJoinEnd">
                      Membership registration has ended.
                    </div>
                    <div class="flex gap-4 mt-6" v-else>
                      <button type="button" v-on:click="join('member')"  class="w-full h-36 p-4 leading-6 text-white bg-[#172e59] hover:bg-[#0e1b35] rounded-md flex flex-col justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-white w-8" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                        <div class="mt-4">Member</div>
                      </button> <!-- 동의하기 -->
<!--                      <button type="button" v-on:click="join('business')"  class="w-full h-32 leading-6 text-white bg-[#591734] hover:bg-[#350e1f] rounded-md flex flex-col justify-center items-center">-->
                      <button type="button" v-on:click="join('business')"  class="w-full h-36 p-4 leading-6 text-white bg-[#102b3e] hover:bg-[#07121a] rounded-md flex flex-col justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-white w-8" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M48 0C21.5 0 0 21.5 0 48V464c0 26.5 21.5 48 48 48h96V432c0-26.5 21.5-48 48-48s48 21.5 48 48v80h89.9c-6.3-10.2-9.9-22.2-9.9-35.1c0-46.9 25.8-87.8 64-109.2V271.8 48c0-26.5-21.5-48-48-48H48zM64 240c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V240zm112-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V240c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V240zM80 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm80 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V112zM272 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zM576 272a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM352 477.1c0 19.3 15.6 34.9 34.9 34.9H605.1c19.3 0 34.9-15.6 34.9-34.9c0-51.4-41.7-93.1-93.1-93.1H445.1c-51.4 0-93.1 41.7-93.1 93.1z"/></svg>
                        <div class="mt-4">Business Entity</div>
                      </button> <!-- 동의하기 -->
                      <button v-show="false" type="button" v-on:click="join('consumer')"  class="w-full h-36 p-4 leading-6 text-white bg-[#172e59] hover:bg-[#0e1b35] rounded-md flex flex-col justify-center items-center">
                        <svg xmlns="http://www.w3.org/2000/svg" class="fill-white w-8" viewBox="0 0 640 512"><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304h91.4C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7H29.7C13.3 512 0 498.7 0 482.3zM504 312V248H440c-13.3 0-24-10.7-24-24s10.7-24 24-24h64V136c0-13.3 10.7-24 24-24s24 10.7 24 24v64h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552v64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"/></svg>
                        <div class="mt-4">Consumer</div>
                      </button> <!-- 동의하기 -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block lg:hidden xl:hidden mt-4">
          <SideMenu></SideMenu>
        </div>
      </div>
    </div>
  </section>
  <my-register_agree v-if="is_join == true" :register_type = "register_type" @send_join="get_join"></my-register_agree>


</template>

<script>

import numeral from 'numeral';
import 'numeral/locales';
import VueSimpleAlert from "vue3-simple-alert";
import {  ShoppingCartIcon} from '@heroicons/vue/outline'
import MypageTop from './mypage/MypageTop.vue';
import SideMenu from './mypage/SideMenu.vue';
import Loading from 'vue3-loading-overlay';
import alert from "vue3-simple-alert";
import {createPopper} from "@popperjs/core";
import modalView from "./modalView";
import vSelect from "vue-select";
import dayjs from "dayjs";
import MyRegister_agree from "./MyRegister_agree";

export default {
  name: "MyRegister_join",
  components : {
    MyRegister_agree,
    VueSimpleAlert,
    ShoppingCartIcon,
    MypageTop,
    SideMenu,
    Loading,
    modalView,
    vSelect
  },
  data: () => ({
    i18n: window.i18n,
    laravel: window.Laravel,
    no_search_messsage: '',
    isLoggedIn: false,
    loading : false,
    is_login: false,
    is_join : false,
    register_type : "",
  }),
  computed: {
    isJoinEnd() {
      // Registration allowed through 6/30; blocked from 7/1 00:00:00 (month is 0-based)
      const end = new Date(2026, 6, 1, 0, 0, 0);
      return new Date() >= end;
    },
  },
  beforeCreate() {
    axios.post(window.Laravel.back_url + '/api/getMyConfig', {}, {headers: {Authorization: 'Bearer ' + window.Laravel.access_token}}).then(response => {
      this.myconfig = response.data;

    });

  },
  created() {
  },
  watch : {

  },
  mounted() {
    if (window.Laravel.registerRid) {
      this.isLoggedIn = true;
      this.user = window.Laravel.user;
    }
  },
  methods:{
    get_join(data) {
      this.is_join = !this.is_join;
    },

    // 숫자 포멧
    formatPrice(value,digit) {
      let val = (value/1).toFixed(digit).replace('.', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    join(register_type){
      if (this.isJoinEnd) {
        VueSimpleAlert.alert("Membership registration has ended.","","",{allowOutsideClick : false});
        return;
      }
      this.register_type = register_type;
      this.is_join = true;
    },
  },
}


</script>

<style >
.v-select{ min-width: 100px; z-index:0 }
.m_menu{display:none;}
</style>

